const PAGE_SIZE = 10;

export default {
  defaultPageSize: PAGE_SIZE,
};
